export default "__VITE_ASSET__BHEBDycn__"